import ShowerCommon from "./showerCommon";
import {createParentPositions, ShowerHeadTypes} from "../../constants";

export default class DiverterTrim extends ShowerCommon {
  constructor(isChild) {
    super(isChild);
    this.partId = 'diverter_trim';
    this.partName = 'Diverter Trim';
    this.translateId = "visualizer.bathroom.shower.diverter_trim";
    this.canBeDisabled = true;
    this.disabled = true;
    if (isChild) {
      createParentPositions(this);
    }
  }

  handleClick() {
    this.setArmHeadType();
    super.handleClick();
  }

  hideLayerCondition() {
    const showerParent = this.getParent();
    return showerParent.shower_head_type !== ShowerHeadTypes.shower_arm
  }

}
